<template>
	<div>		
		<v-content>
			<v-container fluid>		
                <center><img style="padding-top: 7%;" src="../../shared/assets/images/3dloader.gif" v-if="loaded == false" /></center>
              <v-flex xs3 v-if="loaded == true">
                <v-text-field v-if="rfcList != '' && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                <v-text-field v-if="rfcList != '' && search == ''" append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>        
				<v-data-table :headers="headers" :pagination.sync="pagination" :search="search" :items="rfcList" class="elevation-1" v-if="loaded == true" :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
                        <td width="7% " class="text-xs-right">{{ props.item.created.substr(0,10) }}</td>
                        <td width="7%" class="text-xs-right">{{ fncGetRfcAge(props.item.created.substr(0,10)) }}</td>
                        <td width="7%" class="text-xs-right">{{ props.item.number }}.{{ props.item.version }}</td>
                        <td width="8%" class="text-xs-right">{{ fncFilter(props.item.creditNoteNumber) }}</td>
                        <td width="8%"class="text-xs-right">{{ fncFilter(props.item.salesReturnNumber) }}</td>
                        <td width="10%" class="text-xs-right">{{ props.item.originator.fullname }}</td>
                        <td width="10%" class="text-xs-right">{{ props.item.customer.fullname }}</td>
                        <td width="11%" class="text-xs-right">{{ props.item.customer.company.name }}</td>
                        <td width="11%" class="text-xs-right">{{ fncCheckDelivery(props.item.deliveryAddressId) }}</td>
                        <td width="5%" class="text-xs-right"><a @click.prevent="fncViewQuote(props.item.id, props.item.number, props.item.customer.id, props.item.customer.fullname, props.item.deliveryAddressId)" href="#"><i class="material-icons">line_style</i></a></td>
                        <td width="10%" class="text-xs-right">{{ props.item.statusDescription }}</td>
                        <td width="6%" class="text-xs-right"><a href="#" @click.prevent="fncRfcStatus(props.item.id, props.item.number)"><i class="material-icons">alarm</i></a></td>
					</template>
				</v-data-table>
			</v-container>
		</v-content>	
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';

  export default {
	name: 'RfcList',
	intRoleEdit: 0,
    data () {
		return {	
            search: '',
            pagination: { 'sortBy': 'created', 'descending': true },
			headers: [         
				{ text: 'RFC Date', value: 'created', width: '7%' },
                { text: 'RFC Age', value: 'created', width: '7%' },
                { text: 'RFC No', value: 'number', width: '7%' },
                { text: 'Credit Note No', value: 'creditNoteNumber', width: '8%' },
                { text: 'SR No', value: 'salesReturnNumber', width: '8%' },
                { text: 'Originator', value: 'originator', width: '10%' },
                { text: 'Customer Name', value: 'customer', width: '10%' },
                { text: 'Customer Company', value: 'company', width: '11%' },
                { text: 'Delivery/Pickup Address', value: 'delivery_address_id', width: '11%' },
                { text: 'View', value: 'viewRfc', width: '5%' },
                { text: 'Status', value: 'statusDescription', width: '10%' },
                { text: 'History', value: 'statusDescription', width: '6%' }
            ],
            loaded: false
		}		
	},
	methods: {
		fncFilter( filterVar ) {
			if( filterVar === '' || filterVar === undefined || filterVar == null || filterVar == 'null' ) {
				return '-';
			} else {
				return filterVar;
			}		
		},
        fncGetRfcAge( created ) {
            var currentDate = new Date();
            var currentDate = currentDate.toISOString().slice(0,10);
            var objCurrent = currentDate.split('-');
            var objCreated = created.split('-');
                currentDate = new Date(objCurrent[0], objCurrent[1], objCurrent[2]);
            var createdDate = new Date(objCreated[0], objCreated[1], objCreated[2]);
            var currentUnix = parseInt(currentDate.getTime() / 1000);
            var createdUnix = parseInt(createdDate.getTime() / 1000);
            var dateDiff = currentUnix - createdUnix;            
            dateDiff = (dateDiff / 60 / 60 / 24) - 1;
            if ( dateDiff < 0 ) {
              dateDiff = 0;
            }
            return dateDiff + ' day(s)';
        },
        fncRfcStatus( rfcId, rfcNumber ) {
            this.$store.dispatch({
                type: 'fncPopulateRfcHistory',
                rfcId: rfcId
            });
            var modalDetails = { title: 'Status History - ' + rfcNumber, component: 'modal-rfc-history', mstate: true, params: {} };
            this.$store.commit({
                type: 'setModal',
                details: modalDetails
            });
        },
        fncCheckDelivery(deliveryId) {
            if( deliveryId === '' || deliveryId === '0' ) {
                return 'Collect';
            } else {
                return 'Deliver';
            }
        },
        fncViewQuote( rfcId, rfcNumber, customerId, customerName, deliveryId ) {
		    this.$store.dispatch({
                type: 'fncViewQuote',
                id: rfcId,
                customerId: customerId,
                customerName: customerName,
                deliveryId: deliveryId,
                number: rfcNumber
            })
        }
	},
	computed: {
		...mapGetters([			
			'objAuthorize',
			'rfcList',
            'rfcSearchList',
			'objRfcFilters'
		])
	},
      beforeMount() {
		if( this.objRfcFilters.originator == 'NaN' ) {
			this.objRfcFilters.originator = '';
		}		
		if( this.objRfcFilters.customer == 'NaN' ) {			
			this.objRfcFilters.customer = '';
		}			        
        this.$store.dispatch('fncPopulateRfcList');
    },
      watch: {
        rfcList() {
          this.loaded = true;
        }
      }
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>